import { render, staticRenderFns } from "./DialogMailPreview.vue?vue&type=template&id=555893d8&"
import script from "./DialogMailPreview.vue?vue&type=script&lang=ts&"
export * from "./DialogMailPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports